import React from 'react';
import clsx from 'clsx';
import { BaseAlertCloseButton, BaseAlertCloseButtonProps } from '../Alert';

export interface ToastCloseButtonProps extends BaseAlertCloseButtonProps {
  /**
   * Функция закрытия тоста. Передается из react-toastify
   */
  closeToast?: () => void;
}

export const ToastCloseButton = ({
  closeToast,
  className
}: ToastCloseButtonProps): JSX.Element => (
  <BaseAlertCloseButton
    className={clsx('hse-Toast__closeButton', className)}
    onClick={closeToast}
  />
);
